'use client'

import { Button } from '@/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { ExternalLink } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'geo-disclaimer-accepted'

export function GeoDisclaimerModal() {
	const t = useTranslations('geoDisclaimer')
	const [isOpen, setIsOpen] = useState(false)
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
		// Check if user has already accepted the disclaimer
		const hasAccepted = localStorage.getItem(STORAGE_KEY)
		if (!hasAccepted) {
			setIsOpen(true)
		}
	}, [])

	const handleAccept = () => {
		localStorage.setItem(STORAGE_KEY, 'true')
		setIsOpen(false)
	}

	const handleDecline = () => {
		// Redirect user away from the site
		window.location.href = 'https://www.google.com'
	}

	// Don't render until mounted to avoid hydration mismatch
	if (!mounted) return null

	return (
		<Dialog open={isOpen} onOpenChange={() => {}}>
			<DialogContent
				className="border-white/10 bg-brand-dark sm:max-w-lg"
				showCloseButton={false}
				onPointerDownOutside={e => e.preventDefault()}
				onEscapeKeyDown={e => e.preventDefault()}
			>
				<DialogHeader className="items-center text-center">
					<Image src="/logos/logo.png" alt="OnAutopilot" width={120} height={40} className="mb-2" />
					<DialogTitle className="text-white text-xl">{t('title')}</DialogTitle>
					<DialogDescription className="mt-4 text-sm text-white/60 leading-relaxed">
						{t('description')}
					</DialogDescription>
					<a
						href="https://docs.polymarket.com/polymarket-learn/FAQ/geoblocking"
						target="_blank"
						rel="noopener noreferrer"
						className="mt-2 inline-flex items-center gap-1 text-sm text-white underline hover:text-white/80"
					>
						{t('restrictedLocationsLink')}
						<ExternalLink className="h-3 w-3" />
					</a>
				</DialogHeader>
				<div className="mt-4 flex flex-col gap-3">
					<Button
						onClick={handleAccept}
						className="w-full bg-brand-blue text-white hover:bg-brand-blue/90"
					>
						{t('acceptButton')}
					</Button>
					<Button
						onClick={handleDecline}
						variant="outline"
						className="w-full border-white/10 text-white/70 hover:bg-white/5 hover:text-white"
					>
						{t('declineButton')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}
